/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_TextInputs */

const en_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No text`)
};

const fr_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun texte`)
};

const de_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Text`)
};

const it_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun testo`)
};

const ru_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст отсутствует`)
};

const es_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin texto`)
};

const zh_cn2_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无文本`)
};

const ja_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストなし`)
};

const hi_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पाठ नहीं है`)
};

const pt_pt2_compare_event_groups_no_text = /** @type {(inputs: Compare_Event_Groups_No_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem texto`)
};

/**
* | output |
* | --- |
* | "No text" |
*
* @param {Compare_Event_Groups_No_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_text = /** @type {((inputs?: Compare_Event_Groups_No_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_no_text(inputs)
	if (locale === "de") return de_compare_event_groups_no_text(inputs)
	if (locale === "it") return it_compare_event_groups_no_text(inputs)
	if (locale === "ru") return ru_compare_event_groups_no_text(inputs)
	if (locale === "es") return es_compare_event_groups_no_text(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_no_text(inputs)
	if (locale === "ja") return ja_compare_event_groups_no_text(inputs)
	if (locale === "hi") return hi_compare_event_groups_no_text(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_no_text(inputs)
	return en_compare_event_groups_no_text(inputs)
});